import LashbrookLogo from '../assets/images/LB_Logoblue.png'
import EmblemLogo from '../assets/images/emblem-black-small.svg';
// import HelzbergLogo from '../assets/images/helzberg.svg';
import HelzbergLogoPink from '../assets/images/helzberg-pink.svg';
import JohnAtencioLogo from '../assets/images/john-atencio-logo.svg';
import BellmansLogo from '../assets/images/Bellmans_logo.png';
import MaviloLogo from '../assets/images/Mavilo-Logo.png';
import ThollotLogo from '../assets/images/Thollot_logo.png';
import LmdLogo from '../assets/images/lmdlogo.svg';
import schubachLogo from '../assets/images/schubach_logo.svg';
import TQDiamondsLogo from '../assets/images/TQDiamonds_Logo.svg';
import ZaanaLogo from '../assets/images/zaana-logo.png';
import TalismanLogo from '../assets/images/talisman.png';
import HerzogLogo from '../assets/images/herzog-logo.png';
import DublinLogo from '../assets/images/dublin-village-logo.png';
import JonesLogo from '../assets/images/logo-jones-bros.png';
import MichelAndSonsLogo from '../assets/images/MichelAndSonsLogo_logo.avif';
import BellaCosaLogo from '../assets/images/bella-cosa-logo.png';
import RobertPalmLogo from '../assets/images/robert-palma-logo.webp';
import ArtofJewelsLogo from '../assets/images/art-of-jewels-logo.png';
import CharlestonLogo from '../assets/images/Charleston-Alexander-Jewelers-logo.png';
import ReisNicholosLogo from '../assets/images/reis-nichols-logo.svg';
import cartersLogo from '../assets/images/carters-logo.png';
import shanecoLogo from '../assets/images/ShaneCo-Custom-Band-logo.svg';
import YatesLogo from '../assets/images/yates-logo.png';
import DalesLogo from '../assets/images/dales-jewelry-logo.webp';
import MillsLogo from '../assets/images/mills-logo.png';
import JDSmithLogo from '../assets/images/jd-smith-logo.avif';
import diamondsByDawnLogo from '../assets/images/diamondsbydawn-logo.avif';
import nasrLogo from '../assets/images/nasr-logo.png';
import bradfordLogo from '../assets/images/bradford-Logo.webp';
import jewelryexpoLogo from '../assets/images/jewelryexpo-logo.png';
import BrynMawrLogo from '../assets/images/bryn-mawr-logo.png';
import JTIDiamondsLogo from '../assets/images/JTI-diamonds-logo.png';
import BaseballRingsLogo from '../assets/images/baseball-rings-logo.webp';
import RevolutionLogo from '../assets/images/revolution_logo.png';
import StonebrookLogo from '../assets/images/stonebrook-logo.webp';
import FoundryLogo from '../assets/images/foundry-logo.png';
import TTGLogo from '../assets/images/TTG-logo.svg';
import DiamondBoiLogo from '../assets/images/Diamondboi-logo.webp';
import PatchDesignsLogo from '../assets/images/patch-designs-logo.webp';
import SarahLeeLogo from '../assets/images/SarahLee-logo.webp';
import HenneLogo from '../assets/images/Henne-Logo.png';
import MRTLogo from '../assets/images/mrt-logo.png';
import GoffLogo from '../assets/images/goff-logo.png';
import SpringersLogo from '../assets/images/springers-logo.png';
import ToodiesLogo from '../assets/images/toodies-logo.png';
import MichaelEllerLogo from '../assets/images/michael-eller-logo.webp';
import HappyJewelersLogo from '../assets/images/HappyJewelersLogo.avif';
import VictoriaJewellersLogo from '../assets/images/victoria-jewellers-logo.webp';
import JonathansJewelryLogo from '../assets/images/jonathans-jewelry-logo.webp';
import NoahsLogo from '../assets/images/noahs-logo.webp';
import ArthursJewelersLogo from '../assets/images/arthurs_jewelers_logo.png';
import SamsFineJewelryLogo from '../assets/images/sams_fine_jewelry_logo.webp';
import RogersJewelryLogo from '../assets/images/rogers-logo.png';
import DiamondsDirectLogo from '../assets/images/diamonds-direct-logo.png';
import PayneAnthonyLogo from '../assets/images/payne-anthony-logo.webp';
import StateStreetLogo from '../assets/images/state_street_logo.png';
import MariasFineJewelryLogo from '../assets/images/marias-logo.webp';
import GeoffreysDiamondsLogo from '../assets/images/geoffreys-diamonds-logo.png';
import BenariJewelersLogo from '../assets/images/benari-logo.png';
import DanielsJewelersLogo from '../assets/images/daniels-logo.png';
import AslanJewelersLogo from '../assets/images/aslan-jewelers-logo.webp';
import PHDJewelersLogo from '../assets/images/phd-jewelers-logo.webp';
import AmptiveLogo from '../assets/images/amptive-logo.png';
import ATThomasJewelersLogo from '../assets/images/a-t-thomas-jewelers-logo.png';
import JerricksFineJewelryLogo from '../assets/images/jerricks-jewelry-logo.webp';
import CharlestonRingsLogo from '../assets/images/charleston-rings-logo.webp';
import CharlesKrypellLogo from '../assets/images/charles-krypell-logo.png';
import AwardcoLogo from '../assets/images/Awardco_Logo.png';
import LegacyTouchLogo from '../assets/images/legacy_touch_logo.avif';
import WexfordJewelersLogo from '../assets/images/wexford_jewelers_logo.png';
import PattonsJewleryLogo from '../assets/images/pattons_jewelry_logo.png';
import FreytagFineJewelryLogo from '../assets/images/freytag_fine_jewelry_logo.png';
import NEFJLogo from '../assets/images/nefj-logo.jpg';
import TDFLogo from '../assets/images/TDF-logo.avif';
import JohnHeroldLogo from '../assets/images/john-herold-logo.webp';
import KayJewelersLogo from '../assets/images/kay-logo.svg';
import ChiccarinesLogo from '../assets/images/chiccarines_logo.webp';
import MarquirettesLogo from '../assets/images/marquirettes_logo.webp';
import HeisersLogo from '../assets/images/heisers_logo.png';
import FrankAdamsLogo from '../assets/images/frank_adams_logo.png';

import { IParams } from '../app/components/RingCustomizerHOC';
import { matchRoutes } from 'react-router-dom';
import { MENS_PATHS, SIGNETS_PATHS, WOMENS_PATHS } from '../routes';
import { IOption } from '../app/types/customizer';

import weddingBand from '../assets/images/wedding-bands.png';
import anniversary from '../assets/images/anniversary.png';
import signet from '../assets/images/signet.png';
import collegiateSignets from '../assets/images/collegiate-signets.png';
import collegiateBand from '../assets/images/collegiate-band.png';
import collegiateSleeve from '../assets/images/collegiate-sleeve.png';

export const isEmpty = (value: any) => value === null || value === undefined || value === '' ||
                        (Array.isArray(value) && value.length === 0);

export type AnyObject = { [key: string]: any };

export const urlToParams = (ring_url: string) => {
  const [pathString, queryString] = ring_url ? ring_url.split('?') : [];

  const routePaths = [
    ...MENS_PATHS,
    ...WOMENS_PATHS,
    ...SIGNETS_PATHS,
  ];

  const matchObj = matchRoutes(routePaths.map(path => ({ path })), ring_url);
  const searchParams = new URLSearchParams(queryString);
  const queryParams: IParams['queryParams'] = Object.fromEntries(searchParams.entries());
  const pathParams: IParams['pathParams'] = matchObj ? matchObj[0].params : {};
  return { pathParams, queryParams };
};


export const defaultRingUrls = {
  'band': '/rings/profiles/D/widths/7/ring_materials/14KW?ring_finish=SATIN&finish_type=F&weight=P&size=10&feature_group=N&sleeve=NONE',
  'womens': '/women/rings/styles/010/ring_materials/14KW/color_arrangements/B/stone_quantities/HALFETERNITY/variants/2?size=7&dia=LABDIA-ST',
  'collegiate_signet': '/rings/collegiate_signet/ring_materials/14KY?ring_finish=POLISH,POLISH,&shape=CIRC&size=SM&shank=T&school=BYU&signet_engraving=BYU2&cerakote_color=NONE&finger_size=10&weight=S',
  'signet': '/rings/signet/ring_materials/14KW?ring_finish=POLISH,POLISH,&shape=CIRC&size=SM&shank=T&finger_size=10&feature_group=N&weight=S'
};

export const getCategorizedOptions = (sku: string, storeData: AnyObject | null) => {
  const { show_women_builder, show_signet_builder, show_collegiate_builder } = storeData || {};

  const list: IOption[] = [];
  list.push({
    name: 'Band',
    type: 'option',
    swatch_url: weddingBand,
    video_url: 'https://lashbrook-customizer-prod.s3.us-west-2.amazonaws.com/categories/Band.mp4',
    selected: false,
    sku: 'band',
  });
  if(show_women_builder) {
    list.push({
      name: 'Anniversary',
      type: 'option',
      swatch_url: anniversary,
      video_url: 'https://lashbrook-customizer-prod.s3.us-west-2.amazonaws.com/categories/Anniversary.mp4',
      selected: false,
      sku: 'womens',
    });
  }
  if(show_signet_builder) {
    list.push({
      name: 'Signet',
      type: 'option',
      swatch_url: signet,
      video_url: 'https://lashbrook-customizer-prod.s3.us-west-2.amazonaws.com/categories/Signet.mp4',
      selected: false,
      sku: 'signet',
    });
  }
  if(show_collegiate_builder) {
    list.push({
      name: 'Collegiate',
      type: 'option',
      swatch_url: collegiateSignets,
      video_url: 'https://lashbrook-customizer-prod.s3.us-west-2.amazonaws.com/categories/Collegiate.mp4',
      selected: false,
      sku: 'collegiate_signet',
    });
  }
  return list.map((item) => {
    if (item.sku === sku) {
      item.selected = true;
    }
    return item;
  });
}

export const getTypeOptions = (sku: string) => {
  if(sku === 'signet') {
    return [];
  } else {
    const list: IOption[] = [
      {
        name: 'Collegiate Signet',
        type: 'option',
        swatch_url: collegiateSignets,
        selected: false,
        sku: 'collegiate_signet',
      },
      // {
      //   name: 'Collegiate Band',
      //   type: 'option',
      //   swatch_url: collegiateBand,
      //   selected: false,
      //   sku: 'collegiate_band',
      // },
      // {
      //   name: 'Collegiate Sleeve',
      //   type: 'option',
      //   swatch_url: collegiateSleeve,
      //   selected: false,
      //   sku: 'collegiate_sleeve',
      // },
    ];
    return list.map((item) => {
      if (item.sku === sku) {
        item.selected = true;
      }
      return item;
    });
  }

}


export const DEFAULT_STYLES = {
  brandColor: '#2a77a7',
  brandlogo: `url(${LashbrookLogo})`,
  watermarkBrand: 'lashbrook',
  tabIcon: 'lashbrook-favicon.ico',
  tabTitle: '',
  enablePoweredBy: true,
  enableDefaultDone: true,
  enableMagicNoSearch: true,
  enableMoreInfo: true,
  isStage: true,

  primaryFont: 'Reckless',
  secondaryFont: 'Neue Haas Unica Pro',
  primaryColor: '#003053',
  secondaryColor: '#003053',
  tertiaryColor: '#ffffff',
  primaryBgColor: '#f2f5f7',
  secondaryBgColor: '#ffffff',

  isDashedBorder: true,
  isRoundedBorder: true,
  alignOptions: 'start',
  showfullBorder: false,
  showEstimatedTotal: false,

  primaryBorderColor: '#ddcc7c',
  secondaryBorderColor: '#e9ecef',
  primaryBorderRadius: '8px',
  secondaryBorderRadius: '4px',
  tertiaryBorderRadius: '9999px',
  rcBoxTabCase: 'capitalize',
  sidebarOrder: 0,


  showTopBar: false,
  topBar: {
    showTopContent: false,
    invertColor: false
  },
  logoSubText: false,
  showLearnMore: false,
  showShippingEstimation: true,
  showMagicNumberAtDiscountPopup: false
};

const PARTNERS: { [key: string]: typeof DEFAULT_STYLES } = {
  'customize': {
    brandColor: '#095E4D',
    brandlogo: `url(${EmblemLogo})`,
    watermarkBrand: 'emblem',
    tabIcon: 'favicon.ico',
    tabTitle: '',
    enablePoweredBy: false,
    enableDefaultDone: false,
    enableMagicNoSearch: false,
    enableMoreInfo: true,
    isStage: false,

    primaryFont: 'HK Grotesk',
    secondaryFont: 'HK Grotesk',
    primaryColor: '#000000',
    secondaryColor: '#323232',
    tertiaryColor: '#ffffff',
    primaryBgColor: '#f7f6f4',
    secondaryBgColor: '#ffffff',

    isDashedBorder: true,
    isRoundedBorder: true,
    alignOptions: 'start',
    showfullBorder: false,
    showEstimatedTotal: false,

    primaryBorderColor: '#e0baad',
    secondaryBorderColor: '#e9ecef',
    primaryBorderRadius: '8px',
    secondaryBorderRadius: '4px',
    tertiaryBorderRadius: '9999px',
    rcBoxTabCase: 'capitalize',
    sidebarOrder: 0,

    showTopBar: true,
    topBar: {
      showTopContent: true,
      invertColor: true
    },
    logoSubText: false,
    showLearnMore: false,
    showShippingEstimation: false,
    showMagicNumberAtDiscountPopup: false
  },
  'shaneco': {
    ...DEFAULT_STYLES,

    watermarkBrand: '',
    brandColor: '#000000',
    brandlogo: `url(${shanecoLogo})`,
    tabIcon: 'ShaneCo-favicon.ico',
    enablePoweredBy: false,
    enableDefaultDone: false,
    enableMagicNoSearch: false,
    enableMoreInfo: false,
    isStage: false,

    primaryFont: 'Montserrat',
    secondaryFont: 'Montserrat',
    primaryColor: '#000000',
    secondaryColor: '#202020',
    primaryBorderColor: '#202020',
    primaryBgColor: '#F7F2EF',
    showShippingEstimation: false
  },
  'shaneco-pos': {
    ...DEFAULT_STYLES,

    watermarkBrand: '',
    brandColor: '#000000',
    brandlogo: `url(${shanecoLogo})`,
    tabIcon: 'ShaneCo-favicon.ico',
    enablePoweredBy: false,
    enableDefaultDone: false,
    enableMagicNoSearch: false,
    enableMoreInfo: false,
    isStage: false,

    primaryFont: 'Montserrat',
    secondaryFont: 'Montserrat',
    primaryColor: '#000000',
    secondaryColor: '#202020',
    primaryBorderColor: '#202020',
    primaryBgColor: '#F7F2EF',
    showShippingEstimation: false
  },
  'art-of-jewels': {
    ...DEFAULT_STYLES,

    watermarkBrand: '',
    brandColor: '#000000',
    brandlogo: `url(${ArtofJewelsLogo})`,
    tabIcon: '',
    enablePoweredBy: false,
    isStage: false,
  },
  'diamonds-direct': {
    ...DEFAULT_STYLES,

    brandColor: '#746274',
    brandlogo: `url(${DiamondsDirectLogo})`,
    tabIcon: 'diamonds-direct-favicon.ico',
    isStage: false,
    enablePoweredBy: false,
    enableDefaultDone: false,
  },
  'amptive': {
    ...DEFAULT_STYLES,

    brandColor: '#cda13c',
    brandlogo: `url(${AmptiveLogo})`,
    tabIcon: 'amptive-favicon.ico',
    isStage: false,
    enablePoweredBy: false,
    enableDefaultDone: false,
  },
  'yates': {
    ...DEFAULT_STYLES,

    brandColor: '#000000',
    brandlogo: `url(${YatesLogo})`,
    tabIcon: 'yates-favicon.ico',
    isStage: false,
  },
  'thinkspace': {
    ...DEFAULT_STYLES,

    brandColor: '#000000',
    isStage: false,
  },
  'dales' : {
    ...DEFAULT_STYLES,
    brandlogo: `url(${DalesLogo})`,
    tabIcon: 'dales-favicon.ico',

    isStage: false,
  },
  'mills' : {
    ...DEFAULT_STYLES,
    brandlogo: `url(${MillsLogo})`,
    tabIcon: 'mills-favicon.ico',
    brandColor: '#868eb6',

    isStage: false,
  },
  'mills-jewelers' : {
    ...DEFAULT_STYLES,
    brandlogo: `url(${MillsLogo})`,
    tabIcon: 'mills-favicon.ico',
    brandColor: '#868eb6',

    isStage: false,
  },
  'helzberg': {
    ...DEFAULT_STYLES,
    brandlogo: `url(${HelzbergLogoPink})`,
    // brandlogoSecondary: `url(${HelzbergLogoPink})`,
    brandColor: '#a1204e',

    primaryFont: 'Tenor Sans',
    secondaryFont: 'Tenor Sans',
    primaryColor: '#846C7A',
    secondaryColor: '#846C7A',
    primaryBgColor: '#f6f4f2',
    primaryBorderColor: '#CEB0B2',
    secondaryBorderColor: '#CEB0B2',
    primaryBorderRadius: '0',
    secondaryBorderRadius: '0',
    tertiaryBorderRadius: '0',
    rcBoxTabCase: 'uppercase',
    sidebarOrder: 1,
  },
  'johnAtencio': {
    ...DEFAULT_STYLES,

    brandColor: '#1c1c1c',
    brandlogo: `url(${JohnAtencioLogo})`,
    tabIcon: 'johnAtencio-favicon.ico',

    primaryFont: 'futura-pt,sans-serif',
    secondaryFont: 'futura-pt,sans-serif',
    primaryColor: '#1c1c1c',
    secondaryColor: '#1c1c1c',
    primaryBgColor: '#f1f5f7',
    primaryBorderColor: '#ddcc7c',
    tertiaryBorderRadius: '0px',

    logoSubText: true,
  },
  'bellmans': {
    ...DEFAULT_STYLES,

    brandColor: '#AD172B',
    brandlogo: `url(${BellmansLogo})`,
    tabIcon: 'bellmans-favicon.ico',
  },
  'mavilo': {
    ...DEFAULT_STYLES,

    brandlogo: `url(${MaviloLogo})`,
    tabIcon: 'mavilo-favicon.ico',
    enableDefaultDone: false,
    isStage: true,
  },
  'thollot': {
    ...DEFAULT_STYLES,

    brandColor: 'rgb(68, 21, 74)',
    primaryColor: 'rgb(17, 17, 17)',
    secondaryColor: 'rgb(28, 29, 29)',
    primaryBorderColor: 'rgb(17, 17, 17)',
    primaryBgColor: 'rgb(242, 242, 242)',

    brandlogo: `url(${ThollotLogo})`,
    tabIcon: 'thollot-favicon.ico',
  },
  'lamaison': {
    ...DEFAULT_STYLES,

    brandlogo: `url(${LmdLogo})`,
    tabIcon: 'lamaison-favicon.ico',
  },
  'schubach': {
    ...DEFAULT_STYLES,

    brandlogo: `url(${schubachLogo})`,
    tabIcon: 'schubach-favicon.ico',
  },
  'tqDiamonds': {
    ...DEFAULT_STYLES,

    brandlogo: `url(${TQDiamondsLogo})`,
    tabIcon: 'tqDiamonds-favicon.ico',
  },
  'zaana': {
    ...DEFAULT_STYLES,

    brandlogo: `url(${ZaanaLogo})`,
    tabIcon: 'zaana-favicon.ico',
  },
  'talisman': {
    ...DEFAULT_STYLES,

    brandlogo: `url(${TalismanLogo})`,
    tabIcon: 'talisman-favicon.ico',
    enablePoweredBy: true,
  },
  'herzog': {
    ...DEFAULT_STYLES,

    brandlogo: `url(${HerzogLogo})`,
    tabIcon: 'herzog-favicon.ico',
  },
  'dublin': {
    ...DEFAULT_STYLES,

    brandlogo: `url(${DublinLogo})`,
    tabIcon: 'dublin-favicon.ico',
  },
  'carters': {
    ...DEFAULT_STYLES,

    brandlogo: `url(${cartersLogo})`,
    tabIcon: '',
    tabTitle: 'Lashbrook Ring Builder - Cartersjewels',
    brandColor: "#512a44"
  },
  'jones-bros': {
    ...DEFAULT_STYLES,

    brandlogo: `url(${JonesLogo})`,
    tabIcon: 'jones-favicon.ico',
  },
  "charleston-diamonds": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${CharlestonLogo})`,
    tabIcon: 'charleston-favicon.ico',
  },
  'bella-cosa': {
    ...DEFAULT_STYLES,

    brandlogo: `url(${BellaCosaLogo})`,
    tabIcon: 'bella-favicon.ico',
    brandColor: '#263d8a',
  },
  'michael-and-sons-jewelers': {
    ...DEFAULT_STYLES,

    brandlogo: `url(${MichelAndSonsLogo})`,
    tabIcon: 'michael-and-sons-jewelers-favicon.ico',
    tabTitle: 'Lashbrook Ring Builder - Michael & Sons Jewellers'
  },
  'michael-and-sons': {
    ...DEFAULT_STYLES,

    brandlogo: `url(${MichelAndSonsLogo})`,
    tabIcon: 'michael-and-sons-jewelers-favicon.ico',
    tabTitle: 'Lashbrook Ring Builder - Michael & Sons Jewellers'
  },
  'robert-palma-designs': {
    ...DEFAULT_STYLES,

    brandlogo: `url(${RobertPalmLogo})`,
    tabIcon: 'robert-palma-favicon.png',
    tabTitle: 'Lashbrook Ring Builder - Robert Palma Designs'
  },
  'lashbrook-bands-at-reis-nichols': {
    ...DEFAULT_STYLES,

    brandlogo: `url(${ReisNicholosLogo})`,
    tabIcon: 'nicholos-favicon.ico',
  },
  "jd-smith": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${JDSmithLogo})`,
    tabIcon: 'jd-smith-favicon.ico',
  },
  "dawn": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${diamondsByDawnLogo})`,
    tabIcon: 'diamondsbydawn-favicon.ico',
  },
  "diamonds-by-dawn": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${diamondsByDawnLogo})`,
    tabIcon: 'diamondsbydawn-favicon.ico',
  },
  "nasr": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${nasrLogo})`,
    tabIcon: 'nasr-favicon.ico',
  },
  "brad": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${bradfordLogo})`,
    tabIcon: 'brad-favicon.ico',
  },
  "jewelryexpo": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${jewelryexpoLogo})`,
    tabIcon: 'jewelryexpo-favicon.png',
  },
  "bryn-mawr": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${BrynMawrLogo})`,
    tabIcon: '',
  },
  "jti-diamond": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${JTIDiamondsLogo})`,
    tabIcon: '',
  },
  "baseball-rings": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${BaseballRingsLogo})`,
    tabIcon: 'baseball-rings-favicon.ico',
  },
  "revolution": {
    ...DEFAULT_STYLES,

    watermarkBrand: '',
    brandColor: '#557373',
    brandlogo: `url(${RevolutionLogo})`,
    tabIcon: 'revolution-favicon.png',
    enablePoweredBy: false,
    enableDefaultDone: false,
    enableMagicNoSearch: true,
    isStage: false,
    primaryColor: '#555555',
    secondaryColor: '#555555',
    tertiaryColor: '#ffffff',
    primaryBgColor: '#f7f7f7',
    secondaryBgColor: '#ffffff',
    isDashedBorder: false,
    isRoundedBorder: false,
    primaryBorderColor: '#557373',
    primaryFont: 'Roboto',
    secondaryFont: 'Roboto',
    showLearnMore: false,
    showShippingEstimation: false

  },
  "stonebrook-jewelry": {
    ...DEFAULT_STYLES,

    watermarkBrand: '',
    brandColor: '#a71616',
    brandlogo: `url(${StonebrookLogo})`,
    tabIcon: 'stonebrook-favicon.png',
    enablePoweredBy: false,
    enableDefaultDone: false,
    enableMagicNoSearch: true,
    isStage: false,
    primaryColor: '#555555',
    secondaryColor: '#555555',
    tertiaryColor: '#ffffff',
    primaryBgColor: '#f7f7f7',
    secondaryBgColor: '#ffffff',
    showLearnMore: false,
    showShippingEstimation: false

  },
  "foundry": {
    ...DEFAULT_STYLES,

    watermarkBrand: '',
    brandColor: '#444444',
    brandlogo: `url(${FoundryLogo})`,
    tabIcon: 'foundry-favicon.jpg',
    enablePoweredBy: false,
    enableDefaultDone: false,
    enableMagicNoSearch: true,
    isStage: false,
    primaryColor: '#555555',
    secondaryColor: '#555555',
    tertiaryColor: '#ffffff',
    primaryBgColor: '#f7f7f7',
    secondaryBgColor: '#ffffff',
    showLearnMore: false,
    showShippingEstimation: false

  },
  "the-true-gem": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${TTGLogo})`,
    tabIcon: 'TTG-favicon.ico',
  },
  "diamond-studio": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${DiamondBoiLogo})`,
    tabIcon: 'diamondboi.ico',
    showShippingEstimation: false
  },
  "jewelry-patch": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${PatchDesignsLogo})`,
    tabIcon: 'JPD-favicon.ico',
  },
  "sarah-lee-jewelry": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${SarahLeeLogo})`,
    tabIcon: 'Sarah_Lee-favicon.ico',
  },
  "henne": {
    ...DEFAULT_STYLES,

    brandColor: '#154734',
    brandlogo: `url(${HenneLogo})`,
    tabIcon: '',
  },
  "mrt-jewelers": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${MRTLogo})`,
    tabIcon: 'mrt-favicon.png',
  },
  "goff": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${GoffLogo})`,
    tabIcon: 'goff-favicon.png',
  },
  "springers-jewelers": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${SpringersLogo})`,
    tabIcon: 'springers-favicon.webp',
  },
  "toodies": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${ToodiesLogo})`,
    tabIcon: 'toodies-favicon.ico',
  },
  "michael-eller": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${MichaelEllerLogo})`,
    tabIcon: 'michael-eller-favicon.png',
  },
  "happy-jewelers": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${HappyJewelersLogo})`,
    tabIcon: 'happy-jewelers-favicon.webp',
  },
  "victoria-jewellers": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${VictoriaJewellersLogo})`,
    tabIcon: 'victoria-jewellers-favicon.ico',
  },
  "kay-jewelers": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${KayJewelersLogo})`,
    tabIcon: 'kay-favicon.ico',
    enableDefaultDone: false,
    enablePoweredBy: false,

    primaryFont: 'Neue Haas Unica Pro',
    secondaryFont: 'Neue Haas Unica Pro',
    primaryBgColor: 'white',
    secondaryBgColor: 'white',
    primaryBorderColor: 'black',
    secondaryBorderColor: 'black',
    primaryColor: 'black',
    secondaryColor: 'black',
    brandColor: 'black',

    isDashedBorder: false,
    isRoundedBorder: false,
    alignOptions: 'center',
    showfullBorder: true,
  },
  "jonathans-jewelry": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${JonathansJewelryLogo})`,
    tabIcon: 'jonathans-jewelry-favicon.png',
  },
  "noahs": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${NoahsLogo})`,
    tabIcon: 'noahs-favicon.webp',
  },
  "arthurs-jewelers": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${ArthursJewelersLogo})`,
    tabIcon: 'arthurs-favicon.ico',
  },
  "sams-fine-jewelry": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${SamsFineJewelryLogo})`,
    tabIcon: 'sams-favicon.png',
  },
  "rogers-jewelry": {
    ...DEFAULT_STYLES,

    enableDefaultDone: false,
    brandlogo: `url(${RogersJewelryLogo})`,
    tabIcon: 'rogers-favicon.ico',
    showShippingEstimation: false
  },
  "payne-anthony": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${PayneAnthonyLogo})`,
    tabIcon: 'payne-anthony-favicon.ico',
  },
  "state-street": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${StateStreetLogo})`,
    tabIcon: 'state_street_favicon.ico',
  },
  "marias-fine-jewelry": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${MariasFineJewelryLogo})`,
    tabIcon: 'marias-favicon.png',
  },
  "geoffreys-diamonds": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${GeoffreysDiamondsLogo})`,
    tabIcon: 'geoffreys-diamonds-favicon.webp',
    showShippingEstimation: false
  },
  "benari-jewelers": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${BenariJewelersLogo})`,
    tabIcon: 'benari_favicon.ico',
    showShippingEstimation: false
  },
  "daniels-jewelers": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${DanielsJewelersLogo})`,
    tabIcon: 'daniels_favicon.png',
    brandColor: '#573285',
    enablePoweredBy: true,
    enableDefaultDone: false,
    enableMagicNoSearch: true,
    isStage: false,
    primaryColor: '#25262b',
    secondaryColor: '#25262b',
    tertiaryColor: '#ffffff',
    primaryBgColor: '#f5f3f8',
    secondaryBgColor: '#ffffff',
    primaryBorderColor: '#321761',

    showMagicNumberAtDiscountPopup: true
  },
  "daniels-jewelers-dev": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${DanielsJewelersLogo})`,
    tabIcon: 'daniels_favicon.png',
    brandColor: '#573285',
    enablePoweredBy: true,
    enableDefaultDone: false,
    enableMagicNoSearch: true,
    isStage: false,
    primaryColor: '#25262b',
    secondaryColor: '#25262b',
    tertiaryColor: '#ffffff',
    primaryBgColor: '#f5f3f8',
    secondaryBgColor: '#ffffff',
    primaryBorderColor: '#321761',

    showMagicNumberAtDiscountPopup: true
  },
  "aslan-jewelers": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${AslanJewelersLogo})`,
    tabIcon: 'aslan-jewelers-favicon.png',
    brandColor: '#f7dbc7',
    enablePoweredBy: true,
    enableDefaultDone: false,
    enableMagicNoSearch: true,
    isStage: false,
    primaryColor: '#302718',
    secondaryColor: '#302718',
    tertiaryColor: '#ffffff',
    primaryBgColor: '#fefefe',
    secondaryBgColor: '#ffffff',
    primaryBorderColor: '#302718',
  },
  "phd-jewelers": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${PHDJewelersLogo})`,
    tabIcon: 'phd-jewelers-favicon.png',
    brandColor: '#232e40',
    enablePoweredBy: true,
    enableDefaultDone: true,
    enableMagicNoSearch: true,
    isStage: false,
    primaryColor: '#232e40',
    secondaryColor: '#232e40',
    tertiaryColor: '#ffffff',
    primaryBgColor: '#f9f9f9',
    secondaryBgColor: '#ffffff',
    primaryBorderColor: '#232e40',
  },
  "a-t-thomas-jewelers": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${ATThomasJewelersLogo})`,
    tabIcon: 'a-t-thomas-jewelers-favicon.ico',
    brandColor: '#040349',
    enablePoweredBy: true,
    enableDefaultDone: true,
    enableMagicNoSearch: true,
    isStage: false,
    primaryColor: '#040349',
    secondaryColor: '#040349',
    tertiaryColor: '#ffffff',
    primaryBgColor: '#f8f8f8',
    secondaryBgColor: '#ffffff',
    primaryBorderColor: '#040349',
  },
  "jerricks-fine-jewelry": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${JerricksFineJewelryLogo})`,
    tabIcon: 'jerricks-favicon.png',
    brandColor: '#3d5d1d',
    enablePoweredBy: true,
    enableDefaultDone: true,
    enableMagicNoSearch: true,
    isStage: false,
    primaryColor: '#212529',
    secondaryColor: '#212529',
    tertiaryColor: '#ffffff',
    primaryBgColor: '#f8f8f8',
    secondaryBgColor: '#ffffff',
    primaryBorderColor: '#3d5d1d',
  },
  "charleston-rings": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${CharlestonRingsLogo})`,
    tabIcon: 'charleston-rings-favicon.webp',
    primaryFont: 'Cormorant Garamond',
    secondaryFont: 'Cormorant Garamond',
    brandColor: '#9aa988',
    enablePoweredBy: true,
    enableDefaultDone: true,
    enableMagicNoSearch: true,
    isStage: false,
    primaryColor: '#245232',
    secondaryColor: '#245232',
    tertiaryColor: '#F7F5F3',
    primaryBgColor: '#F7F5F3',
    secondaryBgColor: '#F7F5F3',
    primaryBorderColor: '#245232',
  },
  "charles-krypell": {
    ...DEFAULT_STYLES,

    brandColor: '#ffbf3f',
    primaryBorderColor: '#ffbf3f',
    brandlogo: `url(${CharlesKrypellLogo})`,
    tabIcon: 'charles-krypell_favicon.ico',
    showShippingEstimation: false
  },
  "awardco": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${AwardcoLogo})`,
    tabIcon: 'awardco_favicon.png',
    showShippingEstimation: false,
    enableDefaultDone: false
  },
  "legacy-touch": {
    ...DEFAULT_STYLES,

    watermarkBrand: '',
    brandlogo: `url(${LegacyTouchLogo})`,
    tabIcon: 'legacy_touch_favicon.png',
    brandColor: '#004071',
    showShippingEstimation: true,
    enablePoweredBy: false,
    enableDefaultDone: false,
    primaryFont: 'Lato',
    secondaryFont: 'Lato',
    primaryColor: '#004071',
    primaryBorderColor: '#CCCCCC',
  },
  "legacy-touch-dev": {
    ...DEFAULT_STYLES,

    watermarkBrand: '',
    brandlogo: `url(${LegacyTouchLogo})`,
    tabIcon: 'legacy_touch_favicon.png',
    brandColor: '#004071',
    showShippingEstimation: true,
    enablePoweredBy: false,
    enableDefaultDone: false,
    primaryFont: 'Lato',
    secondaryFont: 'Lato',
    primaryColor: '#004071',
    primaryBorderColor: '#CCCCCC',
  },
  "wexford-jewelers": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${WexfordJewelersLogo})`,
    tabIcon: 'wexford_jewelers_favicon.webp',
    showShippingEstimation: true,
  },
  "pattons-jewelry": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${PattonsJewleryLogo})`,
    tabIcon: 'patton_jewelry_favicon.ico',
    showShippingEstimation: false,
    brandColor: '#52663e',
    enablePoweredBy: true,
    enableDefaultDone: true,
    enableMagicNoSearch: true,
    isStage: false,
    primaryColor: '#000000',
    secondaryColor: '#000000',
    tertiaryColor: '#ffffff',
    primaryBgColor: 'hsla(0,0%,100%,.8)',
    secondaryBgColor: '#ffffff',
    primaryBorderColor: '#52663e',
  },
  "freytag": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${FreytagFineJewelryLogo})`,
    tabIcon: 'Freytag_favicon.webp',
    showShippingEstimation: false,
    brandColor: '#8E00A7',
    enablePoweredBy: true,
    enableDefaultDone: true,
    enableMagicNoSearch: true,
    isStage: false,
    primaryBorderColor: '#8E00A7',
  },
  "nefj": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${NEFJLogo})`,
    tabIcon: 'nefj-favicon.ico',
    showShippingEstimation: false,
    brandColor: '#3172ab',
    primaryColor: '#4d4d4d',
    secondaryColor: '#4d4d4d',
    secondaryBgColor: '#f7f7f7',
    enablePoweredBy: true,
    enableDefaultDone: true,
    enableMagicNoSearch: true,
    isStage: false,
    primaryBorderColor: '#3172ab',
  },
  "diamond-factory-tx": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${TDFLogo})`,
    tabIcon: 'TDF-favicon.webp',
    showShippingEstimation: false,
    brandColor: '#141b4d',
    primaryColor: '#4f4f4f',
    secondaryColor: '#4f4f4f',
    secondaryBgColor: '#f8f8f8',
    enablePoweredBy: true,
    enableDefaultDone: true,
    enableMagicNoSearch: true,
    isStage: false,
    primaryBorderColor: '#141b4d',
  },
  "john-herold": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${JohnHeroldLogo})`,
    tabIcon: 'john-herold-favicon.ico',
    showShippingEstimation: false,
    brandColor: '#ba9858',
    primaryColor: '#4f4f4f',
    secondaryColor: '#4f4f4f',
    secondaryBgColor: 'rgba(142, 137, 128, 0.1)',
    enablePoweredBy: true,
    enableDefaultDone: true,
    enableMagicNoSearch: true,
    isStage: false,
    primaryBorderColor: '#ba9858',
  },
  "chiccarines": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${ChiccarinesLogo})`,
    tabIcon: 'chiccarines_favicon.webp',
    enableDefaultDone: true,
    enablePoweredBy: true,
    enableMagicNoSearch: true,

    primaryBgColor: 'white',
    secondaryBgColor: 'white',
    primaryBorderColor: 'black',
    secondaryBorderColor: 'black',
    primaryColor: 'black',
    secondaryColor: 'black',
    brandColor: 'black',
  },
  "marquirettes": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${MarquirettesLogo})`,
    tabIcon: 'marquirettes_favicon.png',
    enableDefaultDone: true,
    enablePoweredBy: true,
    enableMagicNoSearch: true,

    primaryBgColor: 'rgb(250, 250, 250)',
    primaryBorderColor: 'rgb(218, 145, 0)',
    primaryColor: 'rgb(33, 37, 41)',
    secondaryColor: 'rgb(33, 37, 41)',
    brandColor: 'rgb(14, 59, 108)',
  },
  "middleton": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${process.env.PUBLIC_URL}/middleton_favicon.png)`,
    tabIcon: 'middleton_favicon.png',
    enableDefaultDone: true,
    enablePoweredBy: true,
    enableMagicNoSearch: true,

    primaryBgColor: 'linear-gradient(180deg, #fff5e7 0%, #ffffff 100%)',
    primaryBorderColor: '#C9A646',
    primaryColor: 'rgb(24, 25, 26)',
    secondaryColor: 'rgb(24, 25, 26)',
    brandColor: 'rgb(114, 36, 82)',
  },
  "heisers": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${HeisersLogo})`,
    tabIcon: 'heisers_favicon.png',
    enableDefaultDone: true,
    enablePoweredBy: true,
    enableMagicNoSearch: true,

    primaryBgColor: 'rgb(250, 250, 250)',
    primaryBorderColor: 'rgb(33, 41, 52)',
    primaryColor: 'rgb(34, 53, 91)',
    secondaryColor: 'rgb(34, 53, 91)',
    brandColor: 'rgb(34, 53, 91)',
  },
  "frank-adams": {
    ...DEFAULT_STYLES,

    brandlogo: `url(${FrankAdamsLogo})`,
    tabIcon: 'frank_adams_favicon.png',
    enableDefaultDone: true,
    enablePoweredBy: true,
    enableMagicNoSearch: true,

    primaryBgColor: 'rgb(250, 250, 250)',
    primaryBorderColor: '#424750',
    primaryColor: 'rgb(33, 37, 41)',
    secondaryColor: 'rgb(33, 37, 41)',
    brandColor: '#3172ab',
  },
};

let APP_STYLES: { [key: string]: typeof DEFAULT_STYLES }= {};

for (const prop in PARTNERS) {
  const style = PARTNERS[prop];
  if(style.isStage) {
    APP_STYLES[prop] = style;
    APP_STYLES[`${prop}-stage`] = style;
  } else {
    APP_STYLES[prop] = style;
  }
}

export  { APP_STYLES };